module.exports = __webpack_public_path__ + "media/images/wedding/thumb/23-9392cb65f5f9e10c625cbe2a5df361c1.jpg";